import React from 'react';
import { useSelector } from 'react-redux';
import { SecondaryHeader } from 'organisms/HeaderComponent';
import { Footer } from 'organisms/FooterComponent';
import {
  isEmptyObject,
  getValueOrnull,
  getValueOrDefaultObject,
  getHeaderData,
  getFooterData
} from 'common/utilities/utils';

export const HeaderFooterHOC = Component => {
  const HeaderFooterComponent = props => {
    let segmentedMarketingData = null,
      segmentedFooterData = null;

    const allReducerData = useSelector(data => {
      return {
        homePageContent: getValueOrnull(data?.contentReducer?.response),
        marketPageContent: getValueOrnull(data?.marketConfigReducer?.response),
        tenantReducerContent: getValueOrnull(data?.tenantReducer),
      };
    });

    if (allReducerData.marketPageContent && allReducerData.tenantReducerContent && allReducerData.homePageContent) {
      const {
        header = {},
        footer = {},
      } = getValueOrDefaultObject(allReducerData?.marketPageContent?.headerData);
      segmentedMarketingData = getHeaderData(header);
      segmentedFooterData = getFooterData(footer);
    }

    const userParamsFromStore = useSelector(selectorData => {
      return selectorData.appStateReducer.userStatus;
    });

    return (
      <React.Fragment>
        {getSecondaryHeader(segmentedMarketingData, allReducerData, userParamsFromStore, true, false)}
        {<Component {...props} />}
        {getFooter(segmentedFooterData, props.history, allReducerData)}{' '}
      </React.Fragment>
    );
  };

  return HeaderFooterComponent;
};

export const getSecondaryHeader = (
  segmentedMarketingData,
  allReducerData,
  userParamsFromStore,
  paymentHeader,
  checkoutHeader,
) => {
  return (
    isEmptyObject(segmentedMarketingData) && (
      <SecondaryHeader
        contentData={segmentedMarketingData}
        tenantReducerData={allReducerData.tenantReducerContent}
        userParams={userParamsFromStore}
        paymentHeader={paymentHeader}
        checkoutHeader={checkoutHeader}
      />
    )
  );
};

export const getFooter = (segmentedFooterData, history, allReducerData) => {
  return (
    isEmptyObject(segmentedFooterData) && (
      <Footer
        contentData={segmentedFooterData}
        history={history}
        tenantReducerData={allReducerData.tenantReducerContent}
      />
    )
  );
};
